import { render, staticRenderFns } from "./viewHkrg.vue?vue&type=template&id=a4be80a8&scoped=true"
import script from "./viewHkrg.vue?vue&type=script&lang=js"
export * from "./viewHkrg.vue?vue&type=script&lang=js"
import style0 from "./viewHkrg.vue?vue&type=style&index=0&id=a4be80a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4be80a8",
  null
  
)

export default component.exports